export var FieldType = /*#__PURE__*/function (FieldType) {
  FieldType["NODE"] = "node";
  FieldType["BOOLEAN"] = "boolean";
  FieldType["NUMBER"] = "number";
  FieldType["ANY"] = "any";
  FieldType["STRING"] = "string";
  FieldType["TEXT"] = "text";
  FieldType["CHOICE"] = "choice";
  return FieldType;
}({});
export var ParserNodeType = /*#__PURE__*/function (ParserNodeType) {
  ParserNodeType["NODE"] = "node";
  ParserNodeType["BOOLEAN"] = "boolean";
  ParserNodeType["NUMBER"] = "number";
  ParserNodeType["STRING"] = "string";
  ParserNodeType["RICH_TEXT"] = "richText";
  ParserNodeType["ARRAY_OF"] = "arrayOf";
  ParserNodeType["ONE_OF"] = "oneOf";
  ParserNodeType["OBJECT"] = "object";
  ParserNodeType["FUNCTION"] = "function";
  ParserNodeType["DISCRIMINATOR"] = "discriminator";
  return ParserNodeType;
}({});